import React, { useEffect, FC } from 'react';

import { Box, Stack } from '@chakra-ui/react';

import { BorderedBox } from 'components/DataDisplay/Box/BorderedBox';
import { AlertFilters } from 'containers/Findings/Alerts/Components/AlertsTable/AlertFilters';
import { AlertsTableHeader } from 'containers/Findings/Alerts/Components/AlertsTable/AlertsTableHeader';
import { useFindingsIssueContext } from 'containers/Findings/Alerts/Components/AlertsTable/hooks/context';
import { IndividualAlertsTable } from 'containers/Findings/Alerts/Components/AlertsTable/IndividualAlertsTable';
import { ViewIssuesBy } from 'containers/Findings/Alerts/Components/AlertsTable/ViewIssuesBy';

export const IndividualAlerts: FC = () => {
  const { getAlerts } = useFindingsIssueContext();

  // Refetch only when the request changes; actions refresh explicitly.
  useEffect(() => {
    getAlerts({ skipIfUnchanged: true });
  }, [getAlerts]);

  return (
    <Stack h="full" spacing={5} w="full">
      <AlertsTableHeader />
      <ViewIssuesBy />
      <BorderedBox h="full">
        <Stack h="full" spacing={5}>
          <AlertFilters />
          <Box flex={1} h="full">
            <IndividualAlertsTable />
          </Box>
        </Stack>
      </BorderedBox>
    </Stack>
  );
};
